import { RefObject } from 'react';

import { Box, type BoxProps } from '@vimeo/bokeh';

import { PlaylistProvider, type PlaylistStyles } from '../../hooks/use-playlist';

export interface PlaylistType extends Omit<BoxProps, 'gap'>, PlaylistStyles {}

/**
 * Playlist is a flexible component used to group and display a list of children.
 * Playlist also provides a context for shared styles, and managing the state of the playlist such as pagination and active item.
 */
export function Playlist({
  outerSpacing,
  isFullbleed,
  gap = 300,
  ref,
  ...rest
}: PlaylistType & { ref?: RefObject<HTMLDivElement> }): React.ReactElement {
  return (
    <PlaylistProvider outerSpacing={outerSpacing} gap={gap} isFullbleed={isFullbleed}>
      <Box
        data-testid="playlist"
        display="flex"
        flexDirection="column"
        borderRadius="drawer"
        gap={gap}
        ref={ref}
        {...rest}
      />
    </PlaylistProvider>
  );
}
